var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.00001,
    height: 16.625032,
    viewBox: "0 0 19.00001 16.625032",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.87501,3.6096177 7.125,0.28461768 V 13.015378 l 4.75001,3.325 z m 1.1875,12.7307603 5.6842,-3.979 c 0.1588,-0.1111 0.2533,-0.2926 0.2533,-0.4864 V 0.59375768 c 0,-0.2214 -0.1232,-0.42441 -0.3196,-0.52665 -0.1963,-0.10224 -0.4333,-0.08674 -0.6147,0.04023 L 13.06251,3.6096177 Z M 0.25325005,4.2635877 5.9375,0.28461768 V 13.015378 l -5.00325995,3.5023 c -0.18137,0.127 -0.41832,0.1425 -0.61469,0.0402 C 0.12317005,16.455678 3.9025468e-8,16.252678 3.9025468e-8,16.031278 V 4.7500077 c 0,-0.19375 0.09453001097453,-0.37532 0.253250010974532,-0.48642 z",
    fill: "#ffffff",
    id: "path1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.13bbbc5ed4abd413aa6e63072f6962d7.svg";
export { ForwardRef as ReactComponent };